import React, { useState } from "react";
import { graphql } from "gatsby";
import PageLayout from "../components/PageLayout";
import { Trustpilot } from "../components/Trustpilot";
import { QuoteFormAndSafesitePromise } from "../components/QuoteFormAndSafesitePromise";
import { RelatedProducts } from "../components/RelatedProducts";
import { RelatedArticles } from "../components/RelatedArticles";
import { Faqs } from "../components/Faqs";
import { RelatedCaseStudies } from "../components/RelatedCaseStudies";
import { LocationList } from "../components/LocationList";
import { ThreeDView } from "../components/ThreeDView";
import { ProductGalleryAndPricing } from "../components/ProductGalleryAndPricing";
import { ProductTabs } from "../components/ProductTabs";
import { breadcrumbs, schema } from "../utils/productHelpers";

export default function Product({ data: { page, site } }) {
  const product = page.productData;

  const [tabState, setTabState] = useState("overview");
  // Handle clicking review link next to stars
  function handleReviewLinkClick() {
    window.location.replace(`${window.location.origin}${window.location.pathname}#${document.querySelector('.product-tabs')?.id}`)
    setTabState("reviews");
  }

  return (
    <PageLayout
      seo={page}
      breadcrumbs={breadcrumbs(page)}
      disableSubscribeToNewsletter={page.disableGlobalSubscribeToNewsletterComponent?.disableGlobalSubscribeToNewsletterComponent}
    >
      {schema(page, site)}
      
      <ProductGalleryAndPricing
        product={product}
        page={page}
        handleReviewLinkClick={handleReviewLinkClick}
        showStickyBar={true}
      />

      <ProductTabs
        product={product}
        page={page}
        tabState={tabState}
        setTabState={setTabState}
      />

      {product.threeDView.threeDViewEmbed && (
        <ThreeDView threeDViewEmbed={product.threeDView.threeDViewEmbed} />
      )}

      {product.faqs && product.faqs.length > 0 && (
        <Faqs items={product.faqs} />
      )}

      {product.relatedProducts && product.relatedProducts.length > 0 && (
        <RelatedProducts
          products={product.relatedProducts}
          heading={
            product.pageType === "problem"
              ? "Related Problems"
              : "Related Products"
          }
        />
      )}

      <QuoteFormAndSafesitePromise source={page.uri} />

      <Trustpilot />

      {product.featuredCaseStudies && product.featuredCaseStudies.length > 0 && (
        <RelatedCaseStudies caseStudies={product.featuredCaseStudies} />
      )}

      {product.relatedArticles && product.relatedArticles.length > 0 && (
        <RelatedArticles articles={product.relatedArticles} inversed />
      )}

      <LocationList products={page.wpChildren.nodes} />
    </PageLayout>
  );
}

export const query = graphql`query ($id: String!) {
  site {
    siteMetadata {
      siteUrl
      brand
    }
  }
  page: wpProduct(id: {eq: $id}) {
    ...ProductFields
  }
}`;
